// 函数节流
export default class Throttle {
    private callback: any;
    private timeout: any = 300;
    private timers: any;

    constructor(timeout:number,callback:Function){
        this.callback = callback
        this.timeout = timeout
    }

    public search(val: any): void {
        if (this.timers) {
            clearTimeout(this.timers)
        }
        this.timers = setTimeout(() => {
            this.callback(val);
        }, this.timeout)
    }
}